// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/taskhead-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/bar-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upcoming-widget {
  padding: 1rem;
  padding-top: 0rem;
  background: #ffffff;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.upcoming-widget .tabs {
  display: flex;
  gap: 0;
  margin-bottom: 0.5rem;
  background: #f8fafc;
  border-radius: 8px;
  padding: 4px;
  flex-shrink: 0;
  width: 30%;
}
.upcoming-widget .hearing-sub-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 1rem;
  background: #f1f5f9;
  border-radius: 6px;
  padding: 3px;
  flex-shrink: 0;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  width: 75%;
}
.upcoming-widget .hearing-sub-tabs::-webkit-scrollbar {
  height: 4px;
}
.upcoming-widget .hearing-sub-tabs::-webkit-scrollbar-track {
  background: transparent;
}
.upcoming-widget .hearing-sub-tabs::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}
.upcoming-widget .hearing-sub-tabs button {
  background: none;
  border: none;
  font-size: 0.8rem;
  padding: 8px 18px;
  cursor: pointer;
  position: relative;
  color: #64748b;
  font-weight: 500;
  border-radius: 4px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  white-space: nowrap;
}
.upcoming-widget .hearing-sub-tabs button .tab-count {
  background: rgba(100, 116, 139, 0.1);
  color: #64748b;
  font-size: 0.7rem;
  padding: 0.125rem 0.25rem;
  border-radius: 8px;
  font-weight: 600;
  min-width: 16px;
  text-align: center;
}
.upcoming-widget .hearing-sub-tabs button.active {
  background: var(--success-color);
  color: #fff;
  font-weight: 500;
}
.upcoming-widget .hearing-sub-tabs button.active .tab-count {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}
.upcoming-widget .hearing-sub-tabs button:hover:not(.active) {
  color: #374151;
  background: rgba(255, 255, 255, 0.5);
}
.upcoming-widget button {
  background: none;
  border: none;
  font-size: 0.95rem;
  padding: 8px 18px;
  cursor: pointer;
  position: relative;
  color: #64748b;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.2s ease;
  flex: 1 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.upcoming-widget button .tab-count {
  background: rgba(100, 116, 139, 0.1);
  color: #64748b;
  font-size: 0.75rem;
  padding: 0.125rem 0.375rem;
  border-radius: 10px;
  font-weight: 600;
  min-width: 18px;
  text-align: center;
}
.upcoming-widget button.active {
  background: var(--primary-color);
  color: #fff;
  font-weight: 500;
}
.upcoming-widget button.active .tab-count {
  background: #f3f4f6;
  color: #6b7280;
}
.upcoming-widget button:hover:not(.active) {
  color: #374151;
  background: rgba(255, 255, 255, 0.5);
}
.upcoming-widget .upcoming-content-wrapper {
  flex-grow: 1;
  position: relative;
  overflow: visible;
  padding-bottom: 3rem;
}
.upcoming-widget .upcoming-content-wrapper .upcoming-content-area {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: visible;
  min-height: fit-content;
}
.upcoming-widget .upcoming-content-wrapper .date-section {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  overflow: visible;
  transition: border-color 0.2s ease;
}
.upcoming-widget .upcoming-content-wrapper .date-section:hover {
  border-color: #d1d5db;
}
.upcoming-widget .upcoming-content-wrapper .date-header {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  background: #f9fafb;
  padding: 1rem 1.25rem;
  margin: 0;
  border-bottom: 1px solid #e5e7eb;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.upcoming-widget .upcoming-content-wrapper .date-header .item-count {
  font-size: 0.75rem;
  color: #6b7280;
  background: #e5e7eb;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: normal;
}
.upcoming-widget .upcoming-content-wrapper .items-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card {
  display: flex;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card:last-child {
  border-bottom: none;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card:hover {
  background: #f9fafb;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card:hover::before {
  opacity: 1;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #6b7280;
  opacity: 0;
  transition: opacity 0.2s ease;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-emoji {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  flex-shrink: 0;
  font-size: 1.25rem;
  position: relative;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-emoji .court-type-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  font-size: 9px;
  font-weight: bold;
  padding: 2px 5px;
  border-radius: 10px;
  line-height: 1;
  z-index: 2;
  border: 1px solid rgba(255, 255, 255, 0.8);
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-emoji .court-type-badge.high-court {
  background: linear-gradient(135deg, #1e40af, #3b82f6);
  color: #ffffff;
  box-shadow: 0 2px 4px rgba(30, 64, 175, 0.3);
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-emoji .court-type-badge.district-court {
  background: linear-gradient(135deg, #7c3aed, #a855f7);
  color: #ffffff;
  box-shadow: 0 2px 4px rgba(124, 58, 237, 0.3);
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details {
  flex-grow: 1;
  min-width: 0;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 900;
  color: #6b7280;
  font-size: 0.8rem;
  margin-bottom: 8px;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-title .courtref-displayboard {
  font-size: 12px;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-title .status-chip {
  margin-left: auto;
  font-size: 0.7rem;
  padding: 0.25rem 0.5rem;
  border-radius: 8px;
  font-weight: 600;
  display: flex;
  gap: 4px;
  align-items: center;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-title .status-chip.completed {
  background: #d1fae5;
  color: #065f46;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-title .status-chip.pending {
  background: #fee2e2;
  color: #991b1b;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-title .hearing-parties {
  font-size: 0.8rem;
  color: #6b7280;
  font-weight: 900;
  margin-left: 6px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-sub {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  color: #6b7280;
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card .card-details .card-sub::before {
  flex-shrink: 0;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card.upcoming-task-card .card-emoji {
  background: #f3f4f6;
  color: #6b7280;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card.upcoming-task-card .card-emoji::before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card.hearing-card .card-emoji {
  background: #f3f4f6;
  color: #6b7280;
}
.upcoming-widget .upcoming-content-wrapper .items-grid .upcoming-item-card.hearing-card .card-emoji::before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
}
.upcoming-widget .upcoming-content-wrapper .no-data {
  text-align: center;
  color: #6b7280;
  padding: 3rem 2rem;
  font-size: 0.95rem;
  background: #f9fafb;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  margin-top: 1rem;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to top, rgba(255, 255, 255, 0.95) 60%, transparent);
  cursor: pointer;
  z-index: 10;
  gap: 0.5rem;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container .toggle-text {
  font-size: 0.875rem;
  color: #374151;
  font-weight: 500;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container .toggle-circle {
  width: 32px;
  height: 32px;
  background: #374151;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border: 2px solid #ffffff;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container .toggle-circle .arrow-icon {
  color: #ffffff;
  font-size: 1rem;
  transition: transform 0.3s ease;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container:hover .toggle-circle {
  background: #4b5563;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container:hover .toggle-text {
  color: #111827;
}
.upcoming-widget .upcoming-content-wrapper .show-more-toggle-container.expanded .arrow-icon {
  transform: rotate(180deg);
}
@media (max-width: 768px) {
  .upcoming-widget {
    padding: 1.5rem;
  }
  .upcoming-widget .tabs {
    margin-bottom: 1.5rem;
  }
  .upcoming-widget .hearing-sub-tabs {
    margin-bottom: 1rem;
  }
  .upcoming-widget .hearing-sub-tabs button {
    font-size: 0.75rem;
    padding: 0.4rem 0.6rem;
    gap: 0.25rem;
  }
  .upcoming-widget .hearing-sub-tabs button .tab-count {
    font-size: 0.65rem;
    padding: 0.1rem 0.2rem;
    min-width: 14px;
  }
  .upcoming-widget button {
    font-size: 0.9rem;
    padding: 0.65rem 1rem;
  }
  .upcoming-widget .items-grid .upcoming-item-card {
    padding: 0.875rem 1rem;
  }
  .upcoming-widget .items-grid .upcoming-item-card .card-emoji {
    width: 36px;
    height: 36px;
    margin-right: 0.875rem;
    font-size: 1.1rem;
  }
  .upcoming-widget .items-grid .upcoming-item-card .card-emoji .court-type-badge {
    font-size: 8px;
    padding: 1px 4px;
    top: -3px;
    right: -3px;
  }
  .upcoming-widget .items-grid .upcoming-item-card .card-details .card-title {
    font-size: 0.9rem;
  }
  .upcoming-widget .items-grid .upcoming-item-card .card-details .card-sub {
    font-size: 0.75rem;
  }
}

.ref-with-tooltip {
  position: relative;
  cursor: pointer;
}
.ref-with-tooltip .custom-tooltip {
  position: absolute;
  top: 50%;
  left: 17%;
  transform: translateY(-50%) translateX(8px);
  background: #f5faff;
  color: #1e293b;
  border: 1px solid #dbeafe;
  box-shadow: 0 4px 16px rgba(147, 197, 253, 0.25);
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  font-size: 0.75rem;
  white-space: normal;
  max-width: 300px;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;
}
.ref-with-tooltip:hover .custom-tooltip {
  opacity: 1;
  transform: translateY(-50%) translateX(0);
  pointer-events: auto;
}

.custom-tooltip {
  position: absolute;
  transform: translateX(-50%) translateY(-30%);
  background-color: #333;
  color: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  max-width: 400px;
  word-wrap: break-word;
  z-index: 1000;
  pointer-events: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  line-height: 1.4;
}
.custom-tooltip::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #333;
}`, "",{"version":3,"sources":["webpack://./src/components/UpcomingListWidget/UpcomingListWidget.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;AAEE;EACE,aAAA;EACA,MAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AAAJ;AAIE;EACE,aAAA;EACA,MAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AAFJ;AAII;EACE,WAAA;AAFN;AAKI;EACE,uBAAA;AAHN;AAMI;EACE,mBAAA;EACA,kBAAA;AAJN;AAOI;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AALN;AAOM;EACE,oCAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AALR;AAQM;EACE,gCAAA;EACA,WAAA;EACA,gBAAA;AANR;AAQQ;EACE,oCAAA;EACA,WAAA;AANV;AAUM;EACE,cAAA;EACA,oCAAA;AARR;AAaE;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAXJ;AAaI;EACE,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAXN;AAcI;EACE,gCAAA;EACA,WAAA;EACA,gBAAA;AAZN;AAcM;EACE,mBAAA;EACA,cAAA;AAZR;AAgBI;EACE,cAAA;EACA,oCAAA;AAdN;AAkBE;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AAhBJ;AAkBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;AAhBN;AAmBI;EACE,mBAAA;EACA,yBAAA;EAEA,iBAAA;EACA,kCAAA;AAlBN;AAoBM;EACE,qBAAA;AAlBR;AAsBI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AApBN;AAsBM;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AApBR;AAwBI;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AAtBN;AAwBM;EACE,aAAA;EAEA,qBAAA;EACA,gCAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAvBR;AAyBQ;EACE,mBAAA;AAvBV;AA0BQ;EACE,mBAAA;AAxBV;AA0BU;EACE,UAAA;AAxBZ;AA4BQ;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;AA1BV;AA6BQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AA3BV;AA8BU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,0CAAA;AA5BZ;AA8BY;EACE,qDAAA;EACA,cAAA;EACA,4CAAA;AA5Bd;AA+BY;EACE,qDAAA;EACA,cAAA;EACA,6CAAA;AA7Bd;AAkCQ;EACE,YAAA;EAEA,YAAA;AAjCV;AAmCU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAjCZ;AAmCY;EACE,eAAA;AAjCd;AAoCY;EACE,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AAlCd;AAoCc;EACE,mBAAA;EACA,cAAA;AAlChB;AAqCc;EACE,mBAAA;EACA,cAAA;AAnChB;AAuCY;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,uBAAA;AAtCd;AA4CU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EAEA,uBAAA;AA3CZ;AA6CY;EACE,cAAA;AA3Cd;AAmDU;EACE,mBAAA;EACA,cAAA;AAjDZ;AAmDY;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;AAjDd;AA+GU;EACE,mBAAA;EACA,cAAA;AA7GZ;AA+GY;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;AA7Gd;AAqHI;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;AAnHN;AAsHI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,+EAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;AArHN;AAuHM;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AArHR;AAwHM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;AAtHR;AAwHQ;EACE,cAAA;EACA,eAAA;EACA,+BAAA;AAtHV;AA2HQ;EAEE,mBAAA;AA1HV;AA6HQ;EACE,cAAA;AA3HV;AA+HM;EACE,yBAAA;AA7HR;AAmIE;EArfF;IAsfI,eAAA;EAhIF;EAkIE;IACE,qBAAA;EAhIJ;EAmIE;IACE,mBAAA;EAjIJ;EAmII;IACE,kBAAA;IACA,sBAAA;IACA,YAAA;EAjIN;EAmIM;IACE,kBAAA;IACA,sBAAA;IACA,eAAA;EAjIR;EAsIE;IACE,iBAAA;IACA,qBAAA;EApIJ;EAuIE;IACE,sBAAA;EArIJ;EAuII;IACE,WAAA;IACA,YAAA;IACA,sBAAA;IACA,iBAAA;EArIN;EAuIM;IACE,cAAA;IACA,gBAAA;IACA,SAAA;IACA,WAAA;EArIR;EA0IM;IACE,iBAAA;EAxIR;EA2IM;IACE,kBAAA;EAzIR;AACF;;AA+IA;EACE,kBAAA;EACA,eAAA;AA5IF;AA8IE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gDAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,0CAAA;EACA,UAAA;EACA,kDAAA;EACA,oBAAA;AA5IJ;AA+IE;EACE,UAAA;EACA,yCAAA;EACA,oBAAA;AA7IJ;;AAkJA;EACE,kBAAA;EACA,4CAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,oBAAA;EACA,yCAAA;EACA,gBAAA;AA/IF;AAkJE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;AAhJJ","sourcesContent":[".upcoming-widget {\n  padding: 1rem;\n  padding-top: 0rem;\n  background: #ffffff;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  // overflow: hidden;\n\n  .tabs {\n    display: flex;\n    gap: 0;\n    margin-bottom: 0.5rem;\n    background: #f8fafc;\n    border-radius: 8px;\n    padding: 4px;\n    flex-shrink: 0;\n    width: 30%;\n  }\n\n  // Hearing sub-tabs styles\n  .hearing-sub-tabs {\n    display: flex;\n    gap: 0;\n    margin-bottom: 1rem;\n    background: #f1f5f9;\n    border-radius: 6px;\n    padding: 3px;\n    flex-shrink: 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n    white-space: nowrap;\n    width: 75%;\n    \n    &::-webkit-scrollbar {\n      height: 4px;\n    }\n    \n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n    \n    &::-webkit-scrollbar-thumb {\n      background: #cbd5e1;\n      border-radius: 2px;\n    }\n    \n    button {\n      background: none;\n      border: none;\n      font-size: 0.8rem;\n      padding: 8px 18px;\n      cursor: pointer;\n      position: relative;\n      color: #64748b;\n      font-weight: 500;\n      border-radius: 4px;\n      transition: all 0.2s ease;\n      flex-shrink: 0;\n      text-align: center;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 0.375rem;\n      white-space: nowrap;\n\n      .tab-count {\n        background: rgba(100, 116, 139, 0.1);\n        color: #64748b;\n        font-size: 0.7rem;\n        padding: 0.125rem 0.25rem;\n        border-radius: 8px;\n        font-weight: 600;\n        min-width: 16px;\n        text-align: center;\n      }\n\n      &.active {\n        background: var(--success-color);\n        color: #fff;\n        font-weight: 500;\n\n        .tab-count {\n          background: rgba(255, 255, 255, 0.2);\n          color: #fff;\n        }\n      }\n\n      &:hover:not(.active) {\n        color: #374151;\n        background: rgba(255, 255, 255, 0.5);\n      }\n    }\n  }\n\n  button {\n    background: none;\n    border: none;\n    font-size: 0.95rem;\n    padding: 8px 18px;\n    cursor: pointer;\n    position: relative;\n    color: #64748b;\n    font-weight: 500;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n    flex: 1;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n\n    .tab-count {\n      background: rgba(100, 116, 139, 0.1);\n      color: #64748b;\n      font-size: 0.75rem;\n      padding: 0.125rem 0.375rem;\n      border-radius: 10px;\n      font-weight: 600;\n      min-width: 18px;\n      text-align: center;\n    }\n\n    &.active {\n      background: var(--primary-color);\n      color: #fff;\n      font-weight: 500;\n\n      .tab-count {\n        background: #f3f4f6;\n        color: #6b7280;\n      }\n    }\n\n    &:hover:not(.active) {\n      color: #374151;\n      background: rgba(255, 255, 255, 0.5);\n    }\n  }\n\n  .upcoming-content-wrapper {\n    flex-grow: 1;\n    position: relative;\n    overflow: visible;\n    padding-bottom: 3rem;\n\n    .upcoming-content-area {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n      overflow: visible; // Changed from hidden to prevent cutting\n      min-height: fit-content; // Ensure content is not cut\n    }\n\n    .date-section {\n      background: #ffffff;\n      border: 1px solid #e5e7eb;\n      // border-radius: 8px;\n      overflow: visible;\n      transition: border-color 0.2s ease;\n\n      &:hover {\n        border-color: #d1d5db;\n      }\n    }\n\n    .date-header {\n      font-size: 0.875rem;\n      font-weight: 600;\n      color: #374151;\n      background: #f9fafb;\n      padding: 1rem 1.25rem;\n      margin: 0;\n      border-bottom: 1px solid #e5e7eb;\n      text-transform: uppercase;\n      letter-spacing: 0.025em;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      .item-count {\n        font-size: 0.75rem;\n        color: #6b7280;\n        background: #e5e7eb;\n        padding: 0.25rem 0.5rem;\n        border-radius: 12px;\n        font-weight: 500;\n        text-transform: none;\n        letter-spacing: normal;\n      }\n    }\n\n    .items-grid {\n      display: flex;\n      flex-direction: column;\n      gap: 0;\n\n      .upcoming-item-card {\n        display: flex;\n        // align-items: center;\n        padding: 1rem 1.25rem;\n        border-bottom: 1px solid #f1f5f9;\n        transition: all 0.2s ease;\n        cursor: pointer;\n        position: relative;\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        &:hover {\n          background: #f9fafb;\n\n          &::before {\n            opacity: 1;\n          }\n        }\n\n        &::before {\n          content: '';\n          position: absolute;\n          left: 0;\n          top: 0;\n          bottom: 0;\n          width: 3px;\n          background: #6b7280;\n          opacity: 0;\n          transition: opacity 0.2s ease;\n        }\n\n        .card-emoji {\n          width: 40px;\n          height: 40px;\n          border-radius: 8px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          margin-right: 1rem;\n          flex-shrink: 0;\n          font-size: 1.25rem;\n          position: relative;\n\n          // Court type badge styling\n          .court-type-badge {\n            position: absolute;\n            top: -4px;\n            right: -4px;\n            font-size: 9px;\n            font-weight: bold;\n            padding: 2px 5px;\n            border-radius: 10px;\n            line-height: 1;\n            z-index: 2;\n            border: 1px solid rgba(255, 255, 255, 0.8);\n            \n            &.high-court {\n              background: linear-gradient(135deg, #1e40af, #3b82f6);\n              color: #ffffff;\n              box-shadow: 0 2px 4px rgba(30, 64, 175, 0.3);\n            }\n            \n            &.district-court {\n              background: linear-gradient(135deg, #7c3aed, #a855f7);\n              color: #ffffff;\n              box-shadow: 0 2px 4px rgba(124, 58, 237, 0.3);\n            }\n          }\n        }\n\n        .card-details {\n          flex-grow: 1;\n          // overflow: hidden;\n          min-width: 0;\n\n          .card-title {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            font-weight: 900;\n            color: #6b7280;\n            font-size: 0.8rem;\n            margin-bottom: 8px;\n\n            .courtref-displayboard {\n              font-size: 12px;\n            }\n\n            .status-chip {\n              margin-left: auto;\n              font-size: 0.7rem;\n              padding: 0.25rem 0.5rem;\n              border-radius: 8px;\n              font-weight: 600;\n              display: flex;\n              gap: 4px;\n              align-items: center;\n\n              &.completed {\n                background: #d1fae5;\n                color: #065f46;\n              }\n\n              &.pending {\n                background: #fee2e2;\n                color: #991b1b;\n              }\n            }\n\n            .hearing-parties {\n              font-size: 0.8rem;\n              color: #6b7280;\n              font-weight: 900;\n              margin-left: 6px;\n              white-space: nowrap;\n              // overflow: hidden;\n              text-overflow: ellipsis;\n            }\n\n          }\n\n\n          .card-sub {\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            font-size: 0.8rem;\n            color: #6b7280;\n            font-weight: 500;\n            white-space: nowrap;\n            // overflow: hidden;\n            text-overflow: ellipsis;\n\n            &::before {\n              flex-shrink: 0;\n            }\n\n          }\n\n        }\n\n        &.upcoming-task-card {\n          .card-emoji {\n            background: #f3f4f6;\n            color: #6b7280;\n\n            &::before {\n              content: '';\n              display: inline-block;\n              width: 22px;\n              height: 22px;\n              background-image: url('../../assets/images/taskhead-icon.png'); // Put the correct path here\n              background-size: contain;\n              background-repeat: no-repeat;\n            }\n          }\n        }\n\n        &.hearing-card {\n          // .card-emoji {\n          //   background: #f3f4f6;\n          //   color: #6b7280;\n\n          //   &::before {\n          //     content: '';\n          //     display: inline-block;\n          //     width: 24px;\n          //     height: 24px;\n          //     background-image: url('../../assets/images/bar-icon.png'); // Put the correct path here\n          //     background-size: contain;\n          //     background-repeat: no-repeat;\n          //   }\n          // }\n\n          // // High Court hearing card styling\n          // &.hearing-card--high-court {\n          //   //border-left: 3px solid #3b82f6;\n          //   background: linear-gradient(to right, #eff6ff, #ffffff);\n\n          //   &:hover {\n          //     background: linear-gradient(to right, #dbeafe, #f9fafb);\n          //     //border-left-color: #1e40af;\n\n          //     &::before {\n          //       background: #1e40af;\n          //     }\n          //   }\n\n          //   .card-emoji {\n          //     background: linear-gradient(135deg, #dbeafe, #eff6ff);\n          //     border: 1px solid #bfdbfe;\n          //     color: #1e40af;\n          //   }\n          // }\n\n          // // District Court hearing card styling\n          // &.hearing-card--district-court {\n          //   //border-left: 3px solid #a855f7;\n          //   background: linear-gradient(to right, #faf5ff, #ffffff);\n\n          //   &:hover {\n          //     background: linear-gradient(to right, #f3e8ff, #f9fafb);\n          //     //border-left-color: #7c3aed;\n\n          //     &::before {\n          //       background: #7c3aed;\n          //     }\n          //   }\n\n          //   .card-emoji {\n          //     background: linear-gradient(135deg, #f3e8ff, #faf5ff);\n          //     border: 1px solid #ddd6fe;\n          //     color: #7c3aed;\n          //   }\n          // }\n          .card-emoji {\n            background: #f3f4f6;\n            color: #6b7280;\n\n            &::before {\n              content: '';\n              display: inline-block;\n              width: 22px;\n              height: 22px;\n              background-image: url('../../assets/images/bar-icon.png');\n              background-size: contain;\n              background-repeat: no-repeat;\n            }\n\n          }\n        }\n      }\n    }\n\n    .no-data {\n      text-align: center;\n      color: #6b7280;\n      padding: 3rem 2rem;\n      font-size: 0.95rem;\n      background: #f9fafb;\n      border: 2px dashed #d1d5db;\n      border-radius: 8px;\n      margin-top: 1rem;\n    }\n\n    .show-more-toggle-container {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      // padding: 1rem 0;\n      background: linear-gradient(to top, rgba(255, 255, 255, 0.95) 60%, transparent);\n      cursor: pointer;\n      z-index: 10;\n      gap: 0.5rem;\n\n      .toggle-text {\n        font-size: 0.875rem;\n        color: #374151;\n        font-weight: 500;\n      }\n\n      .toggle-circle {\n        width: 32px;\n        height: 32px;\n        background: #374151;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: all 0.2s ease;\n        border: 2px solid #ffffff;\n\n        .arrow-icon {\n          color: #ffffff;\n          font-size: 1rem;\n          transition: transform 0.3s ease;\n        }\n      }\n\n      &:hover {\n        .toggle-circle {\n          // transform: translateY(-2px);\n          background: #4b5563;\n        }\n\n        .toggle-text {\n          color: #111827;\n        }\n      }\n\n      &.expanded .arrow-icon {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  // Responsive design\n  @media (max-width: 768px) {\n    padding: 1.5rem;\n\n    .tabs {\n      margin-bottom: 1.5rem;\n    }\n\n    .hearing-sub-tabs {\n      margin-bottom: 1rem;\n      \n      button {\n        font-size: 0.75rem;\n        padding: 0.4rem 0.6rem;\n        gap: 0.25rem;\n\n        .tab-count {\n          font-size: 0.65rem;\n          padding: 0.1rem 0.2rem;\n          min-width: 14px;\n        }\n      }\n    }\n\n    button {\n      font-size: 0.9rem;\n      padding: 0.65rem 1rem;\n    }\n\n    .items-grid .upcoming-item-card {\n      padding: 0.875rem 1rem;\n\n      .card-emoji {\n        width: 36px;\n        height: 36px;\n        margin-right: 0.875rem;\n        font-size: 1.1rem;\n\n        .court-type-badge {\n          font-size: 8px;\n          padding: 1px 4px;\n          top: -3px;\n          right: -3px;\n        }\n      }\n\n      .card-details {\n        .card-title {\n          font-size: 0.9rem;\n        }\n\n        .card-sub {\n          font-size: 0.75rem;\n        }\n      }\n    }\n  }\n}\n\n.ref-with-tooltip {\n  position: relative;\n  cursor: pointer;\n\n  .custom-tooltip {\n    position: absolute;\n    top: 50%; // Center vertically relative to the ref element\n    left: 17%; // Position to the right of the ref element\n    transform: translateY(-50%) translateX(8px); // Center vertically and add small gap\n    background: #f5faff; // very light sky blue\n    color: #1e293b;\n    border: 1px solid #dbeafe; // soft light-blue border\n    box-shadow: 0 4px 16px rgba(147, 197, 253, 0.25);\n    padding: 0.5rem 0.75rem;\n    border-radius: 8px;\n    font-size: 0.75rem;\n    white-space: normal;\n    max-width: 300px;\n    z-index: 9999;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    opacity: 0;\n    transition: opacity 0.3s ease, transform 0.3s ease;\n    pointer-events: none;\n  }\n\n  &:hover .custom-tooltip {\n    opacity: 1;\n    transform: translateY(-50%) translateX(0); // Remove the extra gap on hover\n    pointer-events: auto;\n  }\n}\n\n// Tooltip styles\n.custom-tooltip {\n  position: absolute;\n  transform: translateX(-50%) translateY(-30%);\n  background-color: #333;\n  color: #fff;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  max-width: 400px;\n  word-wrap: break-word;\n  z-index: 1000;\n  pointer-events: none;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  line-height: 1.4;\n\n  // Tooltip arrow\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 0;\n    height: 0;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid #333;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
